(function () {
  function resolveIsSpecialOrder(variant) {
    let isSpecial = false;

    const dataEl = document.getElementById("sas-variant-special-order-data");
    if (variant && dataEl) {
      try {
        const variantsMap = JSON.parse(dataEl.textContent);
        const variantData = variantsMap[String(variant.id)];
        if (variantData?.special_order) {
          isSpecial = true;
        }
      } catch (e) {
        console.warn("Special order JSON parse failed", e);
      }
    }

    if (!isSpecial && variant?.title) {
      const button = document.querySelector(".m-add-to-cart");
      const keyword =
        button?.dataset.specialKeyword?.toLowerCase()?.trim() || "special order";

      if (variant.title.toLowerCase().includes(keyword)) {
        isSpecial = true;
      }
    }

    return isSpecial;
  }

  function updateDeliveryUIAndProperty(isSpecial) {
    document.querySelectorAll("[data-delivery-estimated]").forEach((container) => {
      const normal = container.querySelector("[data-estimated-normal]");
      const special = container.querySelector("[data-estimated-special]");

      if (!normal || !special) return;

      normal.style.display = isSpecial ? "none" : "";
      special.style.display = isSpecial ? "" : "none";
    });

    const normalValueEl = document.querySelector(
      "[data-estimated-normal] .m-product-shipping--content__value"
    );
    const specialValueEl = document.querySelector(
      "[data-estimated-special] .m-product-shipping--content__value"
    );

    let value = "";

    if (isSpecial && specialValueEl) {
      value = specialValueEl.textContent.trim();
    } else if (normalValueEl) {
      value = normalValueEl.textContent.trim();
    }

    if (!value) return;

    document
      .querySelectorAll("input[data-delivery-property]")
      .forEach((input) => {
        input.value = value;
      });
  }

  function updateButton(isSpecial) {
    document.querySelectorAll(".m-add-to-cart").forEach((button) => {
      const textEl = button.querySelector(".m-add-to-cart--text");
      if (!textEl) return;

      if (!textEl.dataset.defaultText) {
        textEl.dataset.defaultText = textEl.textContent.trim();
      }

      const customSpecialTitle = button.dataset.specialTitle?.trim();

      if (isSpecial) {
        textEl.textContent = customSpecialTitle || "Special Order";
        button.classList.add("is-special-order");
      } else {
        textEl.textContent = textEl.dataset.defaultText;
        button.classList.remove("is-special-order");
      }
    });
  }

  document.addEventListener("variant:changed", function (event) {
    const variant = event.detail?.variant;
    if (!variant) return;

    const isSpecial = resolveIsSpecialOrder(variant);

    updateDeliveryUIAndProperty(isSpecial);
    updateButton(isSpecial);
  });

  document.addEventListener("DOMContentLoaded", function () {
    updateDeliveryUIAndProperty(false);
    updateButton(false);
  });
})();
